import { render, staticRenderFns } from "./BaseAtendimentoCliente.vue?vue&type=template&id=1496af9c&scoped=true&"
import script from "./BaseAtendimentoCliente.vue?vue&type=script&lang=js&"
export * from "./BaseAtendimentoCliente.vue?vue&type=script&lang=js&"
import style0 from "./BaseAtendimentoCliente.vue?vue&type=style&index=0&id=1496af9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1496af9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRangeSlider } from 'vuetify/lib/components/VRangeSlider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRangeSlider,VRow})
